import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: width => ({
    width,
    position: 'relative',
  }),
  barText: (isToday, theme) => ({
    position: 'absolute',
    color: isToday ? theme.colors.activeColor : Colors.brownGrey,
  }),
  barCircle: (isToday, theme) => ({
    position: 'absolute',
    top: 30,
    left: 16,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: isToday ? theme.colors.activeColor : theme.colors.cardBackgroundColorTwo,
  }),
  barLine: (isToday, theme) => ({
    position: 'absolute',
    top: 30,
    left: 20,
    width: 1,
    height: '100%',
    borderRadius: 5,
    backgroundColor: isToday ? theme.colors.activeColor : theme.colors.cardBackgroundColorTwo,
    zIndex: 0,
  }),
});
